import api from "./api";

const getAll = () => {
  return api.get("/api/branch/get-all");
};

// branch:read-gated list for the Settings → Branch management page. The plain
// getAll stays ungated because it feeds the global branch selector and filters.
const getAllManaged = () => {
  return api.get("/api/branch/get-all-managed");
};

const saveBranch = (branch, logoFile) => {
  const formData = new FormData();
  Object.keys(branch).forEach((key) => {
    if (branch[key] !== null && branch[key] !== undefined) {
      formData.append(key, branch[key]);
    }
  });
  if (logoFile) {
    formData.append("logo", logoFile);
  }
  return api.post("/api/branch/save", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

const deleteBranch = (id) => {
  return api.post("/api/branch/delete", { branchId: id });
};

const updateBranch = (branch, logoFile, removeLogo) => {
  const formData = new FormData();
  Object.keys(branch).forEach((key) => {
    if (branch[key] !== null && branch[key] !== undefined) {
      formData.append(key, branch[key]);
    }
  });
  if (logoFile) {
    formData.append("logo", logoFile);
  }
  if (removeLogo) {
    formData.append("removeLogo", "true");
  }
  return api.post("/api/branch/update", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

// The branch's default pay rules — what its people are measured under when
// they have no assignment of their own. Same contract as the per-user call:
// only the keys being changed are sent; null means the branch says nothing.
const assignOtRule = (branchId, patch = {}) => {
  const allowed = ["otDaily8", "otWeekly40", "dtOver12", "dtSeventhDay"];
  const body = { branchId };
  for (const key of allowed) {
    if (patch[key] !== undefined) body[key] = patch[key];
  }
  return api.post("/api/branch/assign_ot_rule", body);
};

// Pay rules for one role within a branch — "all managers in Hawaii". Sits
// between the branch's default and a person's own rule. Same contract as the
// other two calls; a rule cleared to all-null is removed server-side.
const getRolePayRules = () => {
  return api.get("/api/branch/role_pay_rules");
};

const assignRoleOtRule = (branchId, roleId, patch = {}) => {
  const allowed = ["otDaily8", "otWeekly40", "dtOver12", "dtSeventhDay"];
  const body = { branchId, roleId };
  for (const key of allowed) {
    if (patch[key] !== undefined) body[key] = patch[key];
  }
  return api.post("/api/branch/assign_role_ot_rule", body);
};

const BranchService = {
  assignOtRule,
  getRolePayRules,
  assignRoleOtRule,
  getAll,
  getAllManaged,
  saveBranch,
  deleteBranch,
  updateBranch,
};

export default BranchService;
